export const VPN = "VPN"